import React, { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useSettingsPageStyles } from '../../hooks/settingsPageStylesHook'

import { Box, Collapse, FormHelperText, FormLabel, Grid } from '@material-ui/core'
import { CircleCheckbox } from '../CircleCheckbox'

import { defaultAutoShipmentStatuses, myOrderStatusNames } from '../../common/orderStatuses'

import { StoreAccountProps } from '../../types/accountProps'
import { MyOrderStatus } from '../../server/mpsklad_core/Entity/MyOrderStatus'

export type AutoShipmentStatusesPickerProps =
  StoreAccountProps & {
  autoShipmentEnabled: boolean

  autoShipmentStatuses: MyOrderStatus[] | undefined

  setAutoShipmentStatuses: (value: MyOrderStatus[] | undefined) => void
}

export const AutoShipmentStatusesPicker =
  observer(
    ({
       account,
       autoShipmentEnabled,
       autoShipmentStatuses,
       setAutoShipmentStatuses
     }: AutoShipmentStatusesPickerProps) => {
      const classes = useSettingsPageStyles()

      useEffect(() => {
        if (autoShipmentStatuses == null) {
          setAutoShipmentStatuses([...defaultAutoShipmentStatuses])
        }
      }, [autoShipmentStatuses, setAutoShipmentStatuses])

      if (autoShipmentStatuses == null) {
        return null
      }

      return (
        <Collapse in={autoShipmentEnabled}>
          {
            autoShipmentEnabled &&
            <Grid item className={classes.root} xs={12}>
              <Box>
                <FormLabel component="legend" className={classes.boldLabel}>
                  Статусы, при которых будет создаваться отгрузка
                </FormLabel>
              </Box>

              {
                account.isDeliveryFromSellerWarehouse
                ?
                <Box display="flex" flexDirection="column">
                  {[
                    MyOrderStatus.Confirmed,
                    MyOrderStatus.Delivering,
                    MyOrderStatus.Delivered
                  ].map(value =>
                    <CircleCheckbox
                      key={value}
                      label={myOrderStatusNames[value]}
                      checked={autoShipmentStatuses?.includes(value) ?? false}
                      onChange={
                        ({target: {checked}}) => setAutoShipmentStatuses(
                          checked ? [...autoShipmentStatuses, value]
                                  : autoShipmentStatuses.filter(_ => _ !== value))}
                    />
                  )}
                </Box>
                :
                <FormHelperText className={classes.helperText}>
                  При выбранной схеме работы используются статусы: {
                  defaultAutoShipmentStatuses.map(_ => myOrderStatusNames[_]).join(', ')}.
                </FormHelperText>
              }
            </Grid>
          }
        </Collapse>
      )
    })